import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/menuController');

export default class MenuService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarMenuPorRole() {
    return await this.axios.get(`/listarMenuPorRole`);
  };

  async listarMenu(tipoAcesso?: string) {
    return await this.axios.get('/listarMenu', {
      params: { 
        tipoAcesso: tipoAcesso 
      }
    });
  }

  async listarTodosOsMenusParaAdmin() {
  return await this.axios.get(`/listarTodosOsMenusParaAdmin`);
}

  async verificaPermissaoPaginaPorRole(rota: string) {
    return await this.axios.get(`/verificaPermissaoPaginaPorRole?rota=${rota}`);
  };

  async salvarAutorizacoes(payload: { idRole: string; idsMenus: number[] }) {
    return await this.axios.post('/salvarAutorizacoes', payload);
  }

}